// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "title-RnhLU";
export { _1 as "__esModule", _2 as "title" }
export default { "__esModule": _1, "title": _2 }
